import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var captionsOnIcon = /*#__PURE__*/React.createElement("svg", {
  height: "55",
  width: "55",
  fill: "none",
  viewBox: "0 0 55 55",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 7a8 8 0 0 0-8 8v24a8 8 0 0 0 8 8h39a8 8 0 0 0 8-8V15a8 8 0 0 0-8-8H8Zm10.491 30.3c-4.92 0-8.58-3.87-8.58-9.51s3.66-9.51 8.58-9.51c4.35 0 7.02 2.55 7.71 6.24h-3.81c-.63-1.68-1.77-2.82-3.9-2.82-2.94 0-4.68 2.58-4.68 6.09 0 3.48 1.74 6.09 4.68 6.09 2.13 0 3.27-1.14 3.9-2.85h3.81c-.69 3.72-3.36 6.27-7.71 6.27Zm17.959 0c-4.92 0-8.58-3.87-8.58-9.51s3.66-9.51 8.58-9.51c4.35 0 7.02 2.55 7.71 6.24h-3.81c-.63-1.68-1.77-2.82-3.9-2.82-2.94 0-4.68 2.58-4.68 6.09 0 3.48 1.74 6.09 4.68 6.09 2.13 0 3.27-1.14 3.9-2.85h3.81c-.69 3.72-3.36 6.27-7.71 6.27Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { captionsOnIcon as default };
//# sourceMappingURL=captionsOnIcon.js.map
